import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/cagr-calculator',
  component: () => import('../../routes/CagrCalculator.svelte'),
  card: {
    id: 'cagr-calculator',
    title: 'CAGR Calculator',
    description: 'Calculate the compound annual growth rate of your investments over time.',
    icon: 'trending_up',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/cagr-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'CAGR Calculator – Compound Annual Growth Rate Calculator',
    description: 'Free CAGR calculator to measure compound annual growth rate. Calculate investment returns over any time period with year-by-year breakdown and annualized gain.',
  },
};

export default meta;
